import { Badge } from "@/components/ui/badge";

interface StatusBadgeProps {
  status: string | undefined | null;
  size?: "sm" | "default" | "lg";
}

export function StatusBadge({ status, size = "default" }: StatusBadgeProps) {
  const getStatusConfig = (status: string | undefined | null) => {
    if (!status) {
      return {
        label: "Unknown",
        variant: "outline" as const,
        className: "bg-gray-100 text-gray-800 hover:bg-gray-100",
      };
    }

    switch (status.toLowerCase()) {
      case "active":
        return {
          label: "Active",
          variant: "default" as const,
          className: "bg-green-100 text-green-800 hover:bg-green-100",
        };
      case "inactive":
        return {
          label: "Inactive",
          variant: "secondary" as const,
          className: "bg-yellow-100 text-yellow-800 hover:bg-yellow-100",
        };
      case "archived":
        return {
          label: "Archived",
          variant: "outline" as const,
          className: "bg-gray-100 text-gray-800 hover:bg-gray-100",
        };
      case "draft":
        return {
          label: "Draft",
          variant: "outline" as const,
          className: "bg-blue-100 text-blue-800 hover:bg-blue-100",
        };
      case "maintenance":
        return {
          label: "Maintenance",
          variant: "destructive" as const,
          className: "bg-red-100 text-red-800 hover:bg-red-100",
        };
      default:
        return {
          label: status,
          variant: "outline" as const,
          className: "bg-gray-100 text-gray-800 hover:bg-gray-100",
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Badge
      variant={config.variant}
      className={`${config.className} ${size === "sm" ? "text-xs px-1.5 py-0.5" : ""}`}
    >
      {config.label}
    </Badge>
  );
}
